import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'core';

import { logout as logoutUser } from 'core/utils/logout';

export const useCurrentUser = () => {
  const {
    userInfo: currentUser,
    loading,
    error,
  } = useSelector((state: RootState) => state.auth, shallowEqual);

  const logout = useCallback(() => logoutUser(), []);

  return {
    currentUser,
    logout,
    loading,
    error,
  };
};
